import pickBy from 'lodash/pickBy';
import queryString from 'query-string';
import { ActionsObservable, StateObservable, ofType } from 'redux-observable';
import {
  catchError, map, mergeMap, withLatestFrom,
} from 'rxjs/operators';

import { FETCH_INDIVIDUAL_ORDERS_ERROR, FETCH_INDIVIDUAL_ORDERS_REQUEST } from '../../constants/actionTypes';
import { ListResponse, Response } from '../../models/Response';
import { INDIVIDUAL_ORDERS_LIST } from '../../constants/paths';
import { State } from '../../models/State';
import { INDIVIDUAL_ORDERS_LIST_LIMIT } from '../../constants/customizations';
import { IndividualOrderListItem } from '../../models/IndividualOrder';
import { FetchIndividualOrdersRequest } from '../../models/actions';
import { fetchIndividualOrdersError, fetchIndividualOrdersSuccess } from '../../actions/fetchIndividualOrders';
import { handleError } from '../../actions/errors';

const fetchIndividualOrders = (
  action$: ActionsObservable<FetchIndividualOrdersRequest>,
  state$: StateObservable<State>,
  { ajax }: any,
) => action$.pipe(
  ofType(FETCH_INDIVIDUAL_ORDERS_REQUEST),
  withLatestFrom(state$),
  mergeMap(([
    {
      payload:
        {
          page, field, order, status, search,
        },
    },
    {
      authentication: { authToken },
      application: { clubId },
    },
  ]) => {
    const query = queryString.stringify(pickBy({
      offset: ((page || 1) - 1) * INDIVIDUAL_ORDERS_LIST_LIMIT,
    }));

    return ajax({
      url: `${INDIVIDUAL_ORDERS_LIST}?${query}`,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authToken,
      },
      body: JSON.stringify({
        clubId,
        ...((field || order) && ({ sort: { field, order } })),
        ...(status && ({ status })),
        ...(search && ({ search })),
      }),
    }).pipe(
      map(({ response: { data, count } }: Response<ListResponse<IndividualOrderListItem>>) => (
        fetchIndividualOrdersSuccess({ orders: data, count })
      )),
      catchError(error => ([
        handleError(error, FETCH_INDIVIDUAL_ORDERS_ERROR),
        fetchIndividualOrdersError(error),
      ])),
    );
  }),
);

export default fetchIndividualOrders;
